module.exports = __webpack_public_path__ + "img/invoice.302d2b31.svg";